import React from "react";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import {
  AllPublisherRoles,
  PublisherRoleLabel,
  resolvePublisherRole,
} from "@seabrookstudios/pitch2table-core";

/** @type {Record<import("@seabrookstudios/pitch2table-core").PublisherRole, string>} */
const PUBLISHER_ROLE_OVERVIEW = {
  FirstParty: "First party publisher.",
  LocalisationPartner: "Localisation partner.",
  Distributor: "Distributes and may translate games, not a place to pitch designs.",
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PublisherRole[] | undefined} props.publisherRole
 */
export const PublisherRoleChips = ({ publisherRole }) => {
  const roles = resolvePublisherRole(publisherRole).filter((role) =>
    AllPublisherRoles.includes(role)
  );

  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ pt: 1 }}>
      {roles.map((role) => (
        <Tooltip key={role} title={PUBLISHER_ROLE_OVERVIEW[role]} arrow>
          <Chip label={PublisherRoleLabel[role]} size="small" variant="outlined" />
        </Tooltip>
      ))}
    </Stack>
  );
};
